import clsx from 'clsx'

export const types = {
  success: clsx('tw-bg-success-50'),
} as const
